import React, { useState } from "react";
import { Download, Share2, MessageSquare, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { makeGuidePdf } from "@/lib/guidePdf";
import { useLang } from "@/lib/lang";
import { T } from "@/lib/i18n";

const btn = "inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold transition-colors";

export const withLang = (path, lang) => {
  if (lang !== "es") return path;
  const [p, h] = path.split("#");
  return `${p}?lang=es${h ? `#${h}` : ""}`;
};

export const GuideActions = ({ article, path }) => {
  const { lang } = useLang();
  const t = T[lang];
  const [busy, setBusy] = useState(false);
  const link = `${window.location.origin}${withLang(path, lang)}`;
  const message = `${t.shareMsg(article.title, link)}\n\n${t.disclaimer} ${t.helpNow}`;

  const download = async () => {
    setBusy(true);
    try { await makeGuidePdf(article, link, lang); toast.success(t.downloading); }
    finally { setBusy(false); }
  };
  const copy = async () => {
    await navigator.clipboard.writeText(message);
    toast.success(t.copied);
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: article.title, text: message }); } catch { /* closed */ }
    } else copy();
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid={`guide-actions-${article.id}`}>
      <button onClick={download} disabled={busy} className={`${btn} btn-gold`} data-testid={`guide-download-${article.id}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} {t.download}
      </button>
      <button onClick={share} className={`${btn} bg-bsn-midnight text-bsn-parchment hover:bg-bsn-navy`} data-testid={`guide-share-${article.id}`}>
        <Share2 className="w-4 h-4" /> {t.share}
      </button>
      <a href={`sms:?&body=${encodeURIComponent(message)}`} className={`${btn} bg-white border border-bsn-midnight/20 text-bsn-midnight hover:border-bsn-gold`} data-testid={`guide-text-${article.id}`}>
        <MessageSquare className="w-4 h-4" /> {t.text}
      </a>
      <button onClick={copy} className={`${btn} bg-white border border-bsn-midnight/20 text-bsn-midnight hover:border-bsn-gold`} data-testid={`guide-copy-${article.id}`}>
        <Link2 className="w-4 h-4" /> {t.copy}
      </button>
    </div>
  );
};
